// extracted by mini-css-extract-plugin
export default {"main_nav_wrap":"index_main_nav_wrap_xmm5i","main_nav":"index_main_nav_QRRmI","user":"index_user_tRJ-r","box":"index_box_43Pbz","ad":"index_ad_SSEte","logo":"index_logo_e5-Ea"};